import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { ButtonCustom } from '../../../../../components/elements/ButtonCustom';

type QuickNoteSection = {
  onViewFile: () => void;
};
const QuickNoteSection = ({ onViewFile }: QuickNoteSection) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <Stack>
      <Typography style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>Quick Note</Typography>
      <Stack style={{ flexDirection: 'row', gap: 16 }}>
        <InputText
          inputError={errors?.quickNote?.message as string}
          placeholder={'Enter quick note'}
          inputProps={{
            ...register('quickNote')
          }}
        />
        <ButtonCustom style={{ width: '140px' }} label={'View FIle'} onClick={onViewFile} />
      </Stack>
    </Stack>
  );
};

export default QuickNoteSection;
